import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';

import withFieldWrapper from '../hocs/withFieldWrapper';

class InputComponent extends Component {
    static propTypes = {
        rows: PropTypes.number,
        onChange: PropTypes.func,
        input: PropTypes.object,
        type: PropTypes.string,
        placeholder: PropTypes.string
    };

    static defaultProps = {
        type: 'text'
    };

    onChange = e => this.props.onChange(e.target.value);

    render() {
        const { rows, autosize, input: { value, name }, meta, disabled, type, placeholder } = this.props;

        const Component = (rows || autosize) ? Input.TextArea : Input;

        return (
            <Component
                className={(rows || autosize) && 'text-area'}
                disabled={disabled && value && !meta.dirty}
                autosize={autosize}
                value={value}
                type={type}
                onChange={this.onChange}
                placeholder={placeholder}
                rows={rows}
                name={name}
                size="large"
            />
        );
    }
}

export default withFieldWrapper(InputComponent);
